<template>

    <teleport to="#modal">
        <Modal v-model:visible="modal_oda_visible" backdrop>
            <template #header>
                <h2 class="text-xl font-bold mb-3">Confermi di creare l'ordine di acquisto con le seguenti righe?</h2>
            </template>
            <template #main>
                <div class="grid grid-cols-4 gap-2 mb-3">
                    <p class="font-bold">Descrizione</p>
                    <p class="font-bold">Valore</p>
                    <p class="font-bold">Totale costi</p>
                    <p class="font-bold">Totale ordinato</p>
                    <template v-for="(r,i) in TotalizzatoriOdaPerIva">
                        <p :class="[i == 'unknown'? 'text-next-orange': '']">
                            {{ r?.aliquota?.descrizione || "Iva sconosciuta" }}</p>
                        <p :class="[i == 'unknown'? 'text-next-orange': '']">{{
                                $filters.toCurrency(r?.aliquota?.valore) || "Iva sconosciuta"
                            }}</p>
                        <p :class="[i == 'unknown'? 'text-next-orange': '']">{{ r?.totale_costi }} {{valutaAcquistoLabel}}</p>
                        <p :class="[i == 'unknown'? 'text-next-orange': '']">{{ r?.totale_costi_euro }} €</p>
                    </template>
                </div>

                <div class="grid grid-cols-4 gap-2 mb-3">
                    <p class="font-bold">Data scadenza</p>
                    <p class="font-bold">Tipo effetto</p>
                    <p class="font-bold">Valore {{valutaAcquistoLabel}}</p>
                    <p class="font-bold">Valore €</p>
                    <template v-for="(c,i) in listaPianoPagamento.rows">
                        <p>{{ $filters.toDate(c.data_scadenza) }}</p>
                        <p>{{ getTipoEffetto(c.tipo_effetto_id) }}</p>
                        <p>{{ $filters.toCurrency(c.valore) }} {{valutaAcquistoLabel}}</p>
                        <p>{{ $filters.toCurrency(c.valore * (c.conversione)) }} €</p>
                    </template>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-end">
                    <div class="flex justify-end pt-3">
                        <NextButton variant="outline-secondary"
                                    @click="modal_oda_visible = false"
                                    class="col-start-3 py-2 px-4">
                            Annulla
                        </NextButton>
                        <NextButton variant="primary"
                                    @click="createOda"
                                    class="ml-4 py-2 px-4">
                            Conferma <i class="spinner"/>
                        </NextButton>
                    </div>
                </div>
            </template>
        </Modal>
    </teleport>

    <ModalRigaPagamento
        v-model:visible="modal_visible"
        v-model:id="row_model.id"
        v-model:data_scadenza="row_model.data_scadenza"
        v-model:tipo_effetto_id="row_model.tipo_effetto_id"
        v-model:valore="row_model.valore"
        @save="onSave"
        :errors="errors"
        :loading="loading_modal"
    ></ModalRigaPagamento>

    <div class="m-auto px-8 md:px-20 pb-8 pt-3">
        <Alert v-if="!fornitore?.id_gamma" :dismissable="false" class="bg-next-orange drop-shadow-lg mt-3 z-50">
            Il seguente fornitore non ha settato un id Gamma quindi non è possibile generare un ODA
        </Alert>

        <Alert v-if="!canCreateOda" :dismissable="false" class="bg-next-orange drop-shadow-lg mt-3 z-50">
            L'azienda del gruppo Next scelta nel progetto, non è abilitata a su questo fornitore
        </Alert>

        <Alert v-if="error_message" :dismissable="true" @close="error_message = ''"
               class="bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50">
            {{ error_message }}
        </Alert>

        <div class="py-10 flex justify-between">
            <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
        </div>

        <div v-show="!StessaValutaAcquisto" class="bg-next-orange text-white p-3 mb-3 font-bold">
            I record del fornitore non sono nella medesima valuta. Impossibile creare l'ordine di acquisto
        </div>
        <div class="m-auto">
            <div class="flex justify-between">
                <h1 class="pb-5 text-2xl">
                    Sottoprogetto: <span class="font-bold">{{ sottoprogetto?.titolo }}</span> - Fornitore: <span
                    class="font-bold">{{ fornitore.denominazione }}</span>
                </h1>
                <NextButton class="px-10" @click="modal_oda_visible = true"
                            v-show="StessaValutaAcquisto && canCreateOda">Crea ODA
                </NextButton>
            </div>

            <div class="grid grid-cols-12 gap-3 mb-5">

                <CardDivisorioGrigio class="col-span-2">
                    <template v-slot:top>
                        <div class="text-sm"><b>Totale costi</b></div>
                    </template>
                    <template v-slot:bottom>
                        <div>{{
                                Totalizzatori.totale_costi.toCurrencyString()
                            }} {{ valutaAcquistoLabel }}
                        </div>
                    </template>
                </CardDivisorioGrigio>
            </div>

            <div v-for="(i,k) in records" :key="k">
                <div class="border-b-next-atp border-b-2 text-next-atp mb-3">
                    <p class="font-bold">Aliquota: <span>{{
                            k in AliquoteAcquisto ? AliquoteAcquisto[k]?.descrizione : 'Sconosciuta'
                        }}</span></p>
                </div>
                <div class="flex gap-3 mb-3">
                    <p>Totale costi: <span>{{
                            k in TotalizzatoriIva ? TotalizzatoriIva[k]?.totale_costi : 'Sconosciuta'
                        }} {{ valutaAcquistoLabel }}</span></p>
                </div>
                <div class="rotate-x-180 overflow-x-scroll mb-5 pb-3">
                    <OffertaTable
                        class="rotate-x-180 w-full border-separate"
                        actionClass="relative"
                        :ordered_records="i"
                        @order-update="performOrder"
                    >
                    </OffertaTable>
                </div>
            </div>

            <h3 class="font-bold">Piano di pagamento</h3>
            <p>Totale pianificato: {{ TotalePianificato.toCurrencyString() }} {{ valutaAcquistoLabel }}</p>
            <p>Residuo: {{ (Totalizzatori.totale_costi - TotalePianificato).toCurrencyString() }} {{ valutaAcquistoLabel }}</p>
            <div class="rotate-x-180 overflow-x-scroll">

                <NextTable class="rotate-x-180 table-fixed w-full border-separate border-spacing-1 py-4"
                           v-model:cols="righeCols"
                           :rows="listaPianoPagamento.rows">

                    <template v-for="(c, j) in listaPianoPagamento.rows" :key="j" v-slot:[`td_${j}_0`]>
                        {{ $filters.toDate(c.data_scadenza) }}
                    </template>
                    <template v-for="(c, j) in listaPianoPagamento.rows" :key="j" v-slot:[`td_${j}_1`]="{context}">
                        {{ getTipoEffetto(context.row[context.cell.prop]) }}
                    </template>
                    <template v-for="(c, j) in listaPianoPagamento.rows" :key="j" v-slot:[`td_${j}_2`]>
                        {{ $filters.toCurrency(c.valore) }}
                    </template>
                    <template v-for="(c, j) in listaPianoPagamento.rows" :key="j" v-slot:[`td_${j}_3`]>
                        {{ $filters.toCurrency(c.valore * (c.conversione)) }}
                    </template>

                    <template v-for="(c, j) in listaPianoPagamento.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                        <TabellaContextMenu
                            menuClass="shadow absolute flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white"
                            buttonClass="bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange"
                            :context="c"
                            :id="j"
                            teleport_to="#modal"
                            :cmOpener="cmOpener"
                        >
                            <span @click="duplicaRiga(c)" class="w-full hover:text-next-neu mb-2">Duplica</span>
                            <span @click="modificaRiga(c)" class="w-full hover:text-next-neu mb-2">Modifica</span>
                            <ConfirmDelete position="left"
                                           @cancella="cancellaRiga(c,j)">
                                <span class="cursor-pointer hover:text-next-neu">Elimina</span>
                            </ConfirmDelete>
                        </TabellaContextMenu>
                    </template>
                </NextTable>

            </div>

            <div class="flex justify-end">
                <NextButton v-if="StessaValutaAcquisto && canCreateOda" variant="primary" @click="addPianoDiPagamento"
                            class="px-3 py-2">Aggiungi riga di pagamento
                </NextButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue,} from 'vue-class-component';
import {mapActions, mapGetters, mapState} from 'vuex';
import sottoProgettiManager from "../api/SottoProgetti";
import fornitoriManager from "../api/FornitoriManager";
import CardDivisorioGrigio from "@/components/CardDivisorioGrigio.vue";
import OffertaTable from '@/components/OffertaTable.vue';
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import Checkbox from "@/components/Checkbox.vue";
import NextButton from "@/components/NextButton.vue";
import Modal from "@/components/Modal.vue";
import Alert from "@/components/Alert.vue";
import NextTable from "@/components/NextTable.vue";
import TabellaContextMenu from "@/components/TabellaContextMenu.vue";
import ConfirmDelete from "@/components/ConfirmDelete.vue";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import pianoDiPagamentoManager from "../api/PianoDiPagamento";
import ModalRigaPagamento from "@/components/ModalRigaPagamento.vue";
import tipoEffettoManager from "../api/TipoEffetto";
import {v4 as uuidv4} from "uuid";
import Lista from "@/setup/ListaCerca";
import progettiManager from "../api/Progetti";
import pianoDiPagamento from "../api/PianoDiPagamento";


@Options({
    name: 'SottoProgettoDettaglioFornitore',
    components: {
        ConfirmDelete,
        ModalRigaPagamento,
        TabellaContextMenu,
        NextTable,
        Alert,
        Modal,
        NextButton,
        Checkbox,
        Breadcrumbs,
        OffertaTable,
        CardDivisorioGrigio,
    },
    props: {
        id: String,
        idf: String,
    },
    computed: {
        ...mapState('buFieldModule', {
            sottoProgettiCols: (state: any) => state.sottoProgettiCols
        }),
        ...mapGetters('buFieldModule', [
            'OrderedRows',
        ]),
        ...mapGetters('sprjDataManager', [
            "ActiveTab",
            "AliquoteAcquisto",
            "RecordSfusiAcquisto",
            "SelectedRows",
            "RecordPerIvaAcquisto",
            "Sottoprogetto",
            "DatiSottoprogetto",
            "ValutaAcquisto",
            "StessaValutaAcquisto",
            'TotaleCostiEuroProgetto',
            'TotaleCostiProgetto',
            'TotaleUtiliProgetto',
            'TotaleRicaviProgetto',
            'TotaleMol',
            'AcCostoUnitarioNetto',
            'AcCostoTotale',
            'VeBudget',
            'BudgetLordoIva',
            'Utile',
            'CostoVenditaUnitario',
            'Mol',
        ])
    },
    methods: {
        ...mapActions('buFieldModule', [
            'fetchSottoprogettoUserPreference',
            'setAllVisible',
            'setVenditaHidden',
            'setAcquistoHidden',
            'orderChange',
        ]),
        ...mapActions('sprjDataManager', [
            'setSottoprogetto',
            'setDatiSottoprogetto',
            "setFornitoreId",
            "prepareDataForODA",
            "retrieveData",
            'setValute',
            'setFees',
        ]),
    },
})
export default class SottoProgettoDettaglioFornitore extends Vue {

    tipo_effetto_options: any [] = []

    setFornitoreId!: any
    RecordSfusiAcquisto!: any
    ValutaAcquisto!: any
    StessaValutaAcquisto!: any
    RecordPerIvaAcquisto!: any
    AliquoteAcquisto!: any
    Sottoprogetto!: any
    prepareDataForODA!: any
    setVenditaHidden!: any
    setAcquistoHidden!: any
    retrieveData!: any

    TotaleCostiProgetto!: any
    TotaleCostiEuroProgetto!: any
    TotaleRicaviProgetto!: any
    TotaleUtiliProgetto!: any
    setSottoprogetto!: any
    setDatiSottoprogetto!: any

    id!: number | string
    idf!: number | string
    loading = false
    modal_visible = false
    loading_modal = false
    modal_oda_visible = false
    error_message = ''

    sottoprogetto: any = {}
    fornitore: any = {}
    errors: any = {};
    canCreateOda = false;

    row_model = {
        sottoprogetto_id: undefined,
        fornitore_id: undefined,
        id: undefined,
        valore: undefined,
        tipo_effetto_id: undefined,
        data_scadenza: undefined,
    }

    cmOpener: any = setup(() => ContextMenuOpener())
    listaPianoPagamento: any = setup(() => Lista(pianoDiPagamentoManager, this.righeCols))
    confirm!: Promise<any>

    totalizzatori = []
    records = []

    get valutaAcquistoLabel(){
        return this.ValutaAcquisto ? this.ValutaAcquisto.sigla : '€'
    }

    getTipoEffetto(id: string) {
        const val = this.tipo_effetto_options.find(el => el.RDT00_CODEFFETTO == id)
        return val?.RDT00_DESCEFFETTO || '----'
    }

    addPianoDiPagamento() {
        this.errors = {}
        this.modal_visible = true;
    }

    cancellaRiga(row: any, j: number | string) {
        pianoDiPagamentoManager.delete(row.id).then((res) => {
            this.cmOpener.close()
            this.listaPianoPagamento.reset()
        })
    }

    get TotalePianificato() {
        return this.listaPianoPagamento.rows.reduce((acc:number, e:any) => acc + Number(e.valore), 0)
    }

    duplicaRiga(row: any) {
        pianoDiPagamentoManager.clone(row.id).then((res) => {
            this.cmOpener.close()
            this.listaPianoPagamento.reset()
        })
        // const data = {...JSON.parse(JSON.stringify(row)), id: uuidv4()}
        // if (!this.canAddRecord(data.valore)) {
        //     this.errors.valore = ["Il valore totale delle righe supera il totale dei costi"]
        // } else {
        //     this.pianoDiPagamentoRows.push(data)
        // }
    }

    modificaRiga(row: any) {
        this.row_model = {...row}
        this.modal_visible = true;
    }

    reset_model() {
        this.row_model.id = undefined
        this.row_model.valore = undefined
        this.row_model.tipo_effetto_id = undefined
        this.row_model.data_scadenza = undefined
    }

    onSave() {
        this.loading_modal = true
        let promise;
        if (this.row_model.id) {
            promise = pianoDiPagamentoManager.update(this.row_model.id, {...this.row_model, conversione: this.ValutaAcquisto.valore})
        } else {
            promise = pianoDiPagamentoManager.create(this.id, this.idf, {...this.row_model, conversione: this.ValutaAcquisto.valore})
        }
        promise.then((res) => {
            this.listaPianoPagamento.reset()
            this.modal_visible = false;
            this.reset_model()
        }).catch((res: any) => {
            if (res?.response?.status == 422) {
                this.errors = res.response.data.errors
            }
        }).finally(() => {
            this.loading_modal = false
        })
    }

    get TotalizzatoriOdaPerIva() {
        const ret: any = {}
        const rpi = this.RecordPerIvaAcquisto
        for (let i in rpi) {
            ret[i] = {
                aliquota: this.AliquoteAcquisto[i],
                totale_costi: this.TotaleCostiProgetto([{records: rpi[i]}]).toCurrencyString(),
                totale_costi_euro: this.TotaleCostiEuroProgetto([{records: rpi[i]}]).toCurrencyString(),
                totale_ordinato: this.TotaleRicaviProgetto([{records: rpi[i]}]).toCurrencyString(),
                totale_ricavi: this.TotaleUtiliProgetto([{records: rpi[i]}]).toCurrencyString(),
            }
        }
        return ret
    }

    createOda() {
        this.loading_modal = true
        this.prepareDataForODA().then(async (res: any) => {
            try {
                const data = await this.retrieveData()
                // tolgo quello con iva sconosciuta
                data.righe = data.righe.filter((el: any) => el.iva_id !== "unknown")
                data.valuta = this.ValutaAcquisto
                sottoProgettiManager.creaOda(this.id, this.idf, data).then((res) => {
                    this.loading_modal = false
                    this.modal_oda_visible = false
                })
            } catch (el: any) {
                this.error_message = el
            }
        })
    }

    performOrder(cols
                     :
                     string
    ) {
        //@ts-ignore
        this.orderChange(cols).then(() => {
            this.updateSectionData()
        })
    }

    updateSectionData() {
        const b = this.RecordSfusiAcquisto
        //@ts-ignore
        let a = this.OrderedRows(b)
        //@ts-ignore
        this.records = this.recordPerIva(a)
    }

    get TotalizzatoriIva() {
        const ret: any = {}
        const rpi = this.RecordPerIvaAcquisto
        for (let i in rpi) {
            ret[i] = {
                totale_costi: this.TotaleCostiProgetto([{records: rpi[i]}]).toCurrencyString(),
                totale_ordinato: this.TotaleRicaviProgetto([{records: rpi[i]}]).toCurrencyString(),
                totale_ricavi: this.TotaleUtiliProgetto([{records: rpi[i]}]).toCurrencyString(),
            }
        }
        return ret
    }

    async created() {
        sottoProgettiManager.canCreaOda(this.id, this.idf).then(() => {
            this.canCreateOda = true
        }).catch(() => {
            this.canCreateOda = false
        })
        this.listaPianoPagamento.callBinds = [this.id, this.idf]
        this.listaPianoPagamento.reset()
        tipoEffettoManager.tipiEffetto().then((res: any) => {
            this.tipo_effetto_options = res.data
        })

        this.setFornitoreId(this.idf).then(() => {
            return sottoProgettiManager.sottoprogetto(this.id)
        }).then(async (res: any) => {
            await this.setSottoprogetto(res.data)
            return this.setDatiSottoprogetto(JSON.parse(res.data.ultimi_dati))
        }).then(async () => {
            this.sottoprogetto = this.Sottoprogetto
            this.records = this.RecordPerIvaAcquisto
        })

        // this.fetchSottoprogettoUserPreference(this.id)
        this.setVenditaHidden()
        //this.setAcquistoHidden()
        fornitoriManager.fornitore(this.idf).then((res) => {
            this.fornitore = res.data
        })
    }

    get Totalizzatori() {
        const sf = this.RecordSfusiAcquisto
        return {
            totale_costi: this.TotaleCostiProgetto([{records: sf}]),
            totale_costi_euro: this.TotaleCostiEuroProgetto([{records: sf}]),
            totale_ordinato: this.TotaleRicaviProgetto([{records: sf}]),
            totale_ricavi: this.TotaleUtiliProgetto([{records: sf}]),
        }
    }

    get getBreadcrumbsPath() {
        return [
            {
                title: 'Progetto',
                name: 'DettaglioProgetto',
                params: {id: this.sottoprogetto.progetto_id || 0}
            },
            {
                title: 'Sottoprogetto',
                name: 'DettaglioSottoProgetto',
                params: {id: this.id || 0}
            },
            {
                title: 'Fornitori',
                name: 'SottoProgettoListaFornitori',
                params: {id: this.id || 0}
            },
            {
                title: 'Dettaglio'
            }
        ]
    }

    righeCols: any[] = [
        {
            name: 'Data scadenza',
            prop: 'data_scadenza',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-8 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Tipo Effetto',
            prop: 'tipo_effetto_id',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-8 px-2 text-right relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Valore',
            prop: 'valore',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-8 px-2 text-right relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Valore €',
            prop: 'conversione',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-8 px-2 text-right relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },
        // {
        //     name: 'id',
        //     prop: 'id',
        //     orderable: false,
        //     class: 'text-left whitespace-nowrap',
        //     td_class: 'h-8 px-2 text-right relative bg-next-gray-md-dark',
        //     resizable: false
        // },
    ]
}

</script>


<style lang="scss">

</style>
